/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PlayerSources {
  EvanMiya = 'EvanMiya',
  RealGm = 'RealGM',
  Stathead = 'Stathead'
}
